<template>
  <div class="chat-page pr-4">
    <h2 class="pb-2">UniChat</h2>

    <div class="row chat-page-content">
      <div class="col-md-4 col-12 pr-0">
        <conversation-list @selected="openConversation" />
      </div>

      <div class="col-md-8 col-12 pl-0">
        <conversation-box :conversation="conversation" />
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../../../utils/helpers";
import ConversationList from "./components/ConversationList.vue";
import ConversationBox from "./components/ConversationBox.vue";

export default {
  name: 'ChatPage',
  components: {
    ConversationList,
    ConversationBox
  },
  data() {
    return {
      conversation: {}
    }
  },
  mounted() {
    eventBus.$on('delete-chat-room', this.resetConversation);
  },
  methods: {
    openConversation(room) {
      this.conversation = room
    },
    resetConversation() {
      this.conversation = {};
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-page-content {
  height: calc(100vh - 180px);
}
</style>